import React from 'react';
import * as Yup from 'yup';
import { Formik, FormikHelpers } from 'formik';
import { FormHelperText } from '@material-ui/core';
import toast from 'react-hot-toast';

import { StringHelper, ValidationHelper } from '@project/helpers';
import { AddBlackListProps, BaseFormProps, ErrorObject } from '@project/types';
import { Button, FormTextField } from '@project/components';

export const AddBlackListForm: React.FC<BaseFormProps<AddBlackListProps>> = ({
  initialValues,
  submitForm,
  onSuccess,
}) => {
  const _handleFormSubmitError = (
    error: ErrorObject,
    actions: FormikHelpers<AddBlackListProps>,
  ) => {
    actions.setSubmitting(false);
    actions.setStatus(error.detail);
  };

  const _handleSubmission = (
    formData: AddBlackListProps,
    actions: FormikHelpers<AddBlackListProps>,
  ) => {
    submitForm(formData)
      .then(() => {
        onSuccess();
        toast.success('User Black Listed successfully!');
      })
      .catch((error: ErrorObject) => {
        toast.error('Failed To Black List ID Number');
        _handleFormSubmitError(error, actions);
      })
      .finally(() => actions.setSubmitting(false));
  };

  const AddBlackListSchema = Yup.object().shape({
    userId: Yup.string()
      .length(13, 'ID Number must be 13 digits long')
      .test(
        'containsInvalidCharacter',
        'Identifier can only contain letter or number',
        StringHelper.isLettersOrDigits,
      )
      .test('isInvalidIdNumber', 'Identifier is not valid', ValidationHelper.IsLuhnValid)
      .required('ID Number is Required'),
  });

  return (
    <Formik
      initialValues={initialValues}
      validateOnBlur
      validateOnChange
      onSubmit={_handleSubmission}
      validationSchema={AddBlackListSchema}
    >
      {({
        handleSubmit,
        isSubmitting,
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        handleReset,
        status,
      }) => {
        return (
          <form
            onReset={handleReset}
            onSubmit={handleSubmit}
            className="flex flex-auto flex-col gap-3 py-1 mx-7"
          >
            <p className="flex justify-center auth-heading text-center">User Details</p>
            {status && <FormHelperText error>{status}</FormHelperText>}
            <p className=" text-xs text-left">Identification Number :</p>
            <FormTextField
              variableName="userId"
              placeholder="Identification Number"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              required
              className="self-center w-96"
            />
            <Button
              isLoading={isSubmitting}
              onClick={handleSubmit}
              className="w-4/5 bg-secondary hover:bg-secondary-dark text-white text-base self-center my-7"
            >
              Black List User
            </Button>
          </form>
        );
      }}
    </Formik>
  );
};
